import { makeAutoObservable } from 'mobx';

export class MyBetsTooltipState {
    public isActive: boolean = false;

    public constructor() {
        makeAutoObservable(this);
    }

    public handleBlur = (): void => {
        this.isActive = false;
    };

    public handleClick = (): void => {
        this.isActive = !this.isActive;
    };
}
